export const lightTheme = {

    body: '#FFF',
    
    text: '#363537',
    
    toggleBorder: '#FFF',
    
    background: '#363537',

    scrollTrack: "#d9d9d9",

    scrollThumb: "#a8a8a8"

    }
    
    export const darkTheme = {
    
    body: '#202020',
    
    text: '#FAFAFA',
    
    toggleBorder: '#6B8096',
    
    background: '#999',

    scrollTrack: "#1a1a1a",

    scrollThumb: "#444444"
    
    }